// A struck option and the pipe beside it go together: "<strike>10 min</strike> | 30 min" reads "30 min".
const STRUCK_OPTION = /\s*\|?\s*<(strike|s|del)\b[^>]*>[\s\S]*?<\/\1>\s*\|?\s*/gi;
const LINE_BREAK = /<br\s*\/?>/gi;
const TAG = /<[^>]+>/g;
const ENTITY = /&(#\d+|#x[0-9a-f]+|[a-z]+);/gi;

const NAMED_ENTITIES: Record<string, string> = {
  amp: '&',
  lt: '<',
  gt: '>',
  quot: '"',
  apos: "'",
  nbsp: ' ',
};

function decodeEntity(entity: string, code: string): string {
  if (!code.startsWith('#')) return NAMED_ENTITIES[code.toLowerCase()] ?? entity;

  const codePoint =
    code[1]?.toLowerCase() === 'x' ? parseInt(code.slice(2), 16) : parseInt(code.slice(1), 10);

  return Number.isFinite(codePoint) ? String.fromCodePoint(codePoint) : entity;
}

/** Feature copy is stored as HTML; the card wants the plain reading, with the struck "was" gone. */
export function featureText(html: string): string {
  return html
    .replace(STRUCK_OPTION, ' ')
    .replace(LINE_BREAK, ' ')
    .replace(TAG, '')
    .replace(ENTITY, decodeEntity)
    .replace(/\s+/g, ' ')
    .trim();
}
